export const indexKeys = {
  getIndexStatus: ['index', 'getIndexStatus'],
}
